module.exports = __webpack_public_path__ + "img/82.0d4a614.png";